import './App.css';
import FormInfo from './FormInfo.js';

function App() {
  return (
    <div>
      <div className="col-md-6 mx-auto text-center">
         <div className="header-title">
            <h1 className="wv-heading--title">
              THE FINALS rank overlay generator
            </h1>
            <h3>By <a href="https://www.twitch.tv/nykho">Nykho</a></h3>
            <p>Generate your own overlay to show to your viewers your rank in THE FINALS ! <br/> Please not that it won't work unless you're in the top 10000 players.</p>
            <p>Looking for a discord bot to flex your rank to your friends ? Check out the one I created <a href="https://github.com/Nykh0/discord-bot-the-finals">here</a> !</p>
         </div>
      </div>
      <FormInfo />
    </div>
  );
}

export default App;
